module.exports = __webpack_public_path__ + "img/05.40ccef3a.jpg";